import IMask from 'imask';
import { setPinInputs } from '@ts/auth/validatePin';

export const init = () => {
    setHTMXListeners();
    setInteractiveElements();
}

const setInteractiveElements = () => {
    setMobilePhoneMask();
    setValidatePin();
}

const setMobilePhoneMask = () => {
    const phoneInput = document.querySelector('.mask-phone');
    if (phoneInput) {
        IMask(
            phoneInput, {
                mask: '000-000-0000',
                prepare: (value) => {
                    // Remove all non-digits
                    let digits = value.replace(/\D/g, '');

                    // Strip leading country code if present
                    if (digits.length === 11 && digits.startsWith('1')) {
                        digits = digits.slice(1);
                    }

                    return digits;
                }
            }
        )
    }
}

const setValidatePin = () => {
    const pinCode = document.getElementById('pin-code');
    if (!pinCode) return

    setPinInputs('.pin-inputs', '#pin-code');
    
    const pins = document.querySelectorAll('.pin-inputs');
    pins.forEach(pin => {
        // If someone backspaces out any input, clear out the pin
        pin.addEventListener('keydown', (e) => {
            if (e.key === 'Backspace' || e.keyCode === 8) {
                pinCode.value ='';
            }
        });
    });
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSwap', setInteractiveElements);
    document.body.addEventListener('htmx:historyRestore', setInteractiveElements);
}